/**
 * vion-icon v1.0.1
 * (c) 2023 yangling
 * @license MIT
 */

import { defineComponent, computed, openBlock, createElementBlock, normalizeStyle, createElementVNode } from 'vue';

var Call = defineComponent({
  name: "Call",
  props: {
    color: String,
    size: String
  },
  emits: ["click"],
  setup: function setup(props, ctx) {
    var iconStyle = computed(function () {
      return {
        display: "inline-block",
        fontSize: props.size,
        color: props.color,
        width: "1em",
        height: "1em",
        lineHeight: "1em"
      };
    });
    var click = function click(e) {
      return ctx.emit("click", e);
    };
    return {
      iconStyle: iconStyle,
      click: click
    };
  }
});
Call.install = function (app) {
  app.component(Call.name, Call);
};

var _hoisted_1 = /* @__PURE__ */createElementVNode("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [/* @__PURE__ */createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M42.9917 22.6494C44.999 24.6567 45.2259 28.3012 44.8489 29.958C44.5932 31.0806 43.7699 31.4184 43.2653 31.5195L43.1306 31.5424L42.9711 31.5588L42.857 31.5621L34.5319 30.0783C33.8738 29.9567 33.4903 29.6015 33.3024 29.3678L33.2293 29.2698L33.1568 29.1513L32.7015 25.2724L32.6031 25.189L32.4712 25.0919L32.3828 25.0324L32.2784 24.9665L32.091 24.8574L31.8646 24.7382L31.6911 24.6544L31.4988 24.568L31.2872 24.4798L31.0555 24.3905C31.0152 24.3755 30.9741 24.3606 30.9321 24.3456L30.6694 24.2561L30.3853 24.1673L30.0791 24.08L29.7504 23.995L29.3984 23.9131L29.0227 23.8349L28.6225 23.7613L28.1974 23.6929C28.1244 23.682 28.0504 23.6714 27.9753 23.661L27.5115 23.6019C27.3526 23.5834 27.1892 23.5661 27.0214 23.5501L26.5042 23.5061L25.9593 23.4708L25.3862 23.4449C24.9946 23.431 24.5838 23.4238 24.153 23.4244C23.7222 23.425 23.3118 23.4337 22.921 23.4496L22.3493 23.4785C21.9779 23.5011 21.6256 23.5303 21.2916 23.5651L20.8043 23.6211L20.3438 23.6847C20.1947 23.707 20.05 23.7305 19.9096 23.7549L19.5009 23.8311L19.1171 23.9123L18.7577 23.9978L18.422 24.0869L18.1093 24.1787C18.0591 24.1942 18.0098 24.2098 17.9614 24.2254L17.6821 24.3198C17.6374 24.3357 17.5935 24.3515 17.5506 24.3674L17.3033 24.4627L17.0765 24.5575L16.8696 24.6512L16.682 24.7428L16.513 24.8316L16.2931 24.9579L16.1116 25.0735L15.9664 25.1757L15.8254 25.2865L15.7038 25.3987L14.4203 29.165L14.4058 29.2257L14.3786 29.3814L14.3576 29.4727C14.2684 29.805 13.9878 30.2589 12.7206 30.4886L11.6786 30.666L9.86481 30.9519L7.90158 31.2434L6.53665 31.4332L5.76792 31.5305L5.33125 31.5769L5.18486 31.5878L5.09251 31.5894L5.06336 31.5868L4.96068 31.5851L4.86641 31.5777L4.74923 31.5621C4.72803 31.5586 4.70606 31.5547 4.6834 31.5502L4.53993 31.5167C4.06409 31.3874 3.40527 31.024 3.17698 30.009C2.8147 28.3968 2.84331 24.5114 4.88582 22.8265L5.10019 22.6627L5.44887 22.4232L5.83725 22.1716L6.23926 21.9232L6.59274 21.7132L7.1318 21.4063L7.42981 21.243L7.91175 20.9876L8.25596 20.8116L8.80606 20.5406L9.19496 20.3565L9.6013 20.1703L10.0248 19.9829L10.4653 19.795L10.9226 19.6073C11.0001 19.576 11.0784 19.5448 11.1574 19.5137L11.6392 19.3277L12.1371 19.1436C12.2214 19.1132 12.3064 19.0828 12.3921 19.0526L12.9137 18.873C13.0902 18.8137 13.2692 18.7551 13.4508 18.6972L14.0032 18.526L14.5706 18.3601C15.1454 18.1971 15.7424 18.0431 16.3604 17.9015L16.9854 17.7641C19.0918 17.3205 21.428 17.026 23.9535 17.002C28.2769 16.9608 31.8193 17.561 34.6256 18.3841L35.1595 18.546C35.5094 18.6557 35.8471 18.7686 36.1726 18.8839L36.6519 19.0585L37.113 19.236L37.5562 19.4157C37.6286 19.4458 37.7002 19.4759 37.771 19.5061L38.1873 19.6878L38.5857 19.87L38.9663 20.0521L39.3293 20.2332L39.6746 20.4129C39.7307 20.4427 39.786 20.4724 39.8407 20.502L40.1597 20.6781C40.2114 20.7072 40.2624 20.7362 40.3127 20.765L40.7455 21.0201L41.1394 21.2649L41.3805 21.4213L41.7101 21.6441L42.0014 21.8505L42.2547 22.0383L42.5337 22.2559L42.8621 22.5312L42.9917 22.6494Z",
  fill: "currentColor"
})], -1);
var _hoisted_2 = [_hoisted_1];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("i", {
    class: "v-icon",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.click && _ctx.click.apply(_ctx, arguments);
    }),
    style: normalizeStyle(_ctx.iconStyle)
  }, _hoisted_2, 4);
}

Call.render = render;

export { Call as default };
